import { gql } from '@apollo/client';

export const CREATE_REPORTING_PERIOD_MUTATOR = gql`
  mutation createReportingPeriodMutator(
    $group_id: String
    $company_id: String
    $reporting_period: JSON
    $user_email: String
  ) {
    createReportingPeriod(
      group_id: $group_id
      company_id: $company_id
      reporting_period: $reporting_period
      user_email: $user_email
    )
  }
`;

export const UPDATE_REPORTING_PERIOD_MUTATOR = gql`
  mutation updateReportingPeriodMutator(
    $group_id: String
    $company_id: String
    $updated_reporting_period: JSON
    $original_reporting_period: JSON
    $user_email: String
  ) {
    updateReportingPeriod(
      group_id: $group_id
      company_id: $company_id
      updated_reporting_period: $updated_reporting_period
      original_reporting_period: $original_reporting_period
      user_email: $user_email
    )
  }
`;

export const DELETE_REPORTING_PERIOD_MUTATOR = gql`
  mutation deleteReportingPeriodMutator(
    $group_id: String
    $company_id: String
    $reporting_period_id: String
    $reporting_period_name: String
    $user_email: String
  ) {
    deleteReportingPeriod(
      group_id: $group_id
      company_id: $company_id
      reporting_period_id: $reporting_period_id
      reporting_period_name: $reporting_period_name
      user_email: $user_email
    )
  }
`;
